import React from 'react';
import { Button } from './ui/button';
import { Badge } from './ui/badge';
import { Github, Linkedin, Mail, ArrowDown, Code, Database, Globe } from 'lucide-react';
import { personalInfo } from '../data/mockData';

const Home = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-gray-50 to-white">
      <div className="max-w-8xl mx-auto px-6 pt-20">
        <div className="text-center">
          {/* Main Content */}
          <div className="mb-8">
            <Badge variant="secondary" className="mb-4 px-4 py-2 text-sm">
              Available for Opportunities
            </Badge>
            <h1 className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight">
              {personalInfo.name}
            </h1>
            <h2 className="text-2xl md:text-3xl text-gray-600 mb-4 font-light">
              {personalInfo.title}
            </h2>
            <p className="text-lg text-gray-500 mb-8 max-w-2xl mx-auto leading-relaxed">
              {personalInfo.subtitle}
            </p>
          </div>

          {/* Tech Stack Icons */}
          <div className="flex justify-center items-center space-x-8 mb-12">
            <div className="flex items-center space-x-2 text-gray-600">
              <Code size={24} />
              <span className="text-sm font-medium">Java</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-600">
              <Globe size={24} />
              <span className="text-sm font-medium">React</span>
            </div>
            <div className="flex items-center space-x-2 text-gray-600">
              <Database size={24} />
              <span className="text-sm font-medium">MongoDB</span>
            </div>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button 
              size="lg" 
              className="bg-blue-600 hover:bg-blue-700 text-white px-8 py-3"
              onClick={() => scrollToSection('projects')}
            >
              View My Work
            </Button>
            <Button 
              variant="outline" 
              size="lg" 
              className="px-8 py-3 border-gray-300 text-gray-700 hover:bg-gray-50"
              onClick={() => scrollToSection('contact')}
            >
              Get In Touch
            </Button>
          </div>

          {/* Social Links */}
          <div className="flex justify-center space-x-6 mb-12">
            <a
              href={personalInfo.github}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <Github size={20} className="text-gray-700" />
            </a>
            <a
              href={personalInfo.linkedin}
              target="_blank"
              rel="noopener noreferrer"
              className="p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <Linkedin size={20} className="text-gray-700" />
            </a>
            <a
              href={`mailto:${personalInfo.email}`}
              className="p-3 bg-white rounded-full shadow-md hover:shadow-lg transition-all duration-300 hover:-translate-y-1"
            >
              <Mail size={20} className="text-gray-700" />
            </a>
          </div>

          {/* Scroll Indicator */}
          <button
            onClick={() => scrollToSection('about')}
            className="animate-bounce inline-block p-2 text-gray-400 hover:text-gray-600 transition-colors"
          >
            <ArrowDown size={24} />
          </button>
        </div>
      </div>
    </section>
  );
};

export default Home;